import { render, staticRenderFns } from "./RadioWithLableDesc.vue?vue&type=template&id=77fcd9b7&scoped=true&"
import script from "./RadioWithLableDesc.vue?vue&type=script&lang=js&"
export * from "./RadioWithLableDesc.vue?vue&type=script&lang=js&"
import style0 from "./RadioWithLableDesc.vue?vue&type=style&index=0&id=77fcd9b7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77fcd9b7",
  null
  
)

export default component.exports